<mat-card>{{'lists' | translate}}</mat-card>

<div align="end" class="row" style="padding: 10px 0 0 10px ;">

    <button mat-raised-button color="primary" (click)="submit()">
        <mat-icon>done</mat-icon>
        {{'submit' | translate}}
    </button>
</div>

<form [formGroup]="subServiceFieldsDropDownItemsForm" #formDir="ngForm" style="padding-right: 10px;">

    <mat-grid-list cols="11" rowHeight="100px">

        <mat-grid-tile colspan="2">
            <mat-form-field appearance="standard">
                <mat-label>{{'categoryStatus' | translate}}</mat-label>
                <mat-select formControlName="mainServiceStatus" (selectionChange)="selectMainServiceStatusChange()">
                    <mat-option *ngFor="let status of mainServicestatusList" [value]="status.id">
                        {{status.name | translate}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="3">
            &nbsp;
            <mat-form-field appearance="standard">
                <mat-label>{{'mainServices' | translate}}</mat-label>
                <mat-select formControlName="mainServiceId" required #mainSelect
                    (selectionChange)="onSelectMainService()">
                    <mat-option *ngFor="let item of mainServiceList" [value]="item.id">
                        {{item.arabicName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <span>&nbsp;</span>
        </mat-grid-tile>

        <mat-grid-tile colspan="3">
            <mat-form-field appearance="standard">
                <mat-label>{{'subServices' | translate}}</mat-label>
                <mat-select formControlName="subServiceId" required #submainSelect
                    (selectionChange)="onSelectSubServices()">
                    <mat-option *ngFor="let item of subServicesList" [value]="item.id">
                        {{item.arabicName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="3">
            <mat-form-field appearance="standard">
                <mat-label>{{'subServicesField' | translate}}</mat-label>
                <mat-select formControlName="subServiceFieldId" required #subServiceFieldIdSelect
                    (selectionChange)="onSelectSubServiceFields()">
                    <mat-option *ngFor="let item of subServicesFieldsList" [value]="item.id">
                        {{item.label}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>


    </mat-grid-list>


    <div formArrayName="subServiceFieldsDropDownItems">
        <div *ngFor="let item of getSubServiceFieldsDropDownItemsControls();let i = index" [formGroupName]="i">
            <mat-grid-list cols="4" rowHeight="70px">

                <mat-grid-tile>
                    <mat-form-field appearance="standard">
                        <mat-label>{{'arabicName' | translate}}</mat-label>
                        <input matInput formControlName="arabicName">
                        <!-- <mat-error *ngIf="subServiceFieldsForm.controls.label.invalid">حقل اجباري</mat-error> -->
                    </mat-form-field>
                </mat-grid-tile>

                <mat-grid-tile>
                    <mat-form-field appearance="standard">
                        <mat-label>{{'englishName' | translate}}</mat-label>
                        <input matInput formControlName="englishName">
                        <!-- <mat-error *ngIf="subServiceFieldsForm.controls.label.invalid">حقل اجباري</mat-error> -->
                    </mat-form-field>
                </mat-grid-tile>


                <mat-grid-tile>

                    <button type="button" *ngIf="i == getSubServiceFieldsDropDownItemsControls().length -1"
                        mat-icon-button aria-label="Example icon button with a vertical three dot icon"
                        (click)="addSubServiceFieldsDropDownItemsRow()">
                        <mat-icon>add</mat-icon>
                    </button>

                    <button type="button" *ngIf="getSubServiceFieldsDropDownItemsControls().length > 1" mat-icon-button
                        aria-label="Example icon button with a vertical three dot icon" (click)="deleteRow(i)">
                        <mat-icon>delete</mat-icon>
                    </button>

                </mat-grid-tile>

            </mat-grid-list>



        </div>

    </div>
</form>

<app-matspinner [overlay]="spinnerOverlay"></app-matspinner>